<template>
  <!-- -->
  <div class="text-component" >
    <div class="left">
      <div class="text-name" :style="{'color': settingData.textColor, 'font-size': settingData.textSize, '--border-width': settingData.borderWidth, '--border-color': settingData.borderColor}">{{settingData.text}}</div>
      <div class="desc-name" :style="{'color': settingData.descColor, 'font-size': settingData.descSize}">{{settingData.desc}}</div>
    </div>
    <div class="right" :style="{'color': settingData.tagColor, 'font-size': settingData.tagSize}">{{settingData.tagName}}</div>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      settingData: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {text: "请输入标题文本"};
      } else {
        this.settingData = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-component {
  display: flex;
  min-height: 100px;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  .left{
    .text-name{
      font-weight: 500;
      border-left: var(--border-width) solid var(--border-color);
      padding: 0 30px;
      margin: 20px 0;
    }
    .desc-name{
      padding: 0 30px;
    }
  }
  .right{
    padding: 0 30px;
  }
}
</style>